// extracted by mini-css-extract-plugin
export default {"empty-cart-confirmation-modal__empty-cart":"empty-cart-confirmation-modal__empty-cart_IckL6GUh"};